import classNames from "classnames";
import HDSwitch from "./HDSwitch";

interface LabeledSwitchProps {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    className?: string;
    labelClassName?: string;
}

const LabeledSwitch = ({ label, checked, onChange, disabled, className, labelClassName }: LabeledSwitchProps) => {
    return (
        <div className={classNames("flex items-center gap-3", className)}>
            <HDSwitch checked={checked} onChange={onChange} disabled={disabled} srLabel={label} />
            <span
                className={classNames(
                    "text-sm font-semibold leading-6 text-gray-900",
                    disabled && "opacity-50",
                    labelClassName,
                )}
            >
                {label}
            </span>
        </div>
    );
};

export default LabeledSwitch;
